import { Controller } from "react-hook-form";
import { TextControlProps } from "types";
import ErrorMessage from "../error-message/error-message";
import "../text-control/text-control.scss";

export interface MultilineControlProps extends Omit<TextControlProps, "type"> {
	rows?: number;
}

const MultilineControl = (props: MultilineControlProps) => {
	const { control, getValues, formState: { errors } } = props.formMethods ?? { formState: {} };

	const rules: any = {
		required: props.required && "Dato requerido",
		pattern: props.pattern
	};

	if (props.compareTo) {
		rules.validate = {
			compareTo: (value: string) => {
				const fieldValue = getValues?.(props.compareTo!.fieldToCompare);
				return fieldValue === value || props.compareTo!.message;
			}
		};
	}

	return (
		<div className="inputField">
			<Controller
				name={props.name}
				control={control}
				rules={rules}
				defaultValue={""}
				render={({ field }) =>
					<textarea
						className={`${errors?.[props.name] && "is-invalid"}`}
						placeholder={" "}
						maxLength={props.maxLength}
						autoComplete={props.autoComplete ?? "off"}
						tabIndex={props.tabIndex}
						readOnly={props.readOnly}
						rows={props.rows ?? 4}
						style={{ minHeight: "50px", resize: "none" }}
						{...field}
					/>
				}
			/>
			<span>{props.label}</span>
			<ErrorMessage error={errors?.[props.name]} />
		</div>
	);
};

export default MultilineControl;